import { useNavigate } from 'react-router';
import { useAuthFlow } from 'src/modules/authFlow/hooks/useAuthFlow';
import { useRoute } from 'src/router/hooks';

export const ProtectedAuthRoute = ({
  children,
  isAuthenticated
}: {
  children: JSX.Element;
  isAuthenticated: boolean | undefined;
}) => {
  const navigate = useNavigate();
  const { ROUTE } = useRoute();
  const { startRegistration } = useAuthFlow();

  if (!isAuthenticated) {
    navigate(ROUTE.MAIN.get());
    startRegistration({ replace: true });

    return null;
  }
  return children;
};
